// LOCAL STORAGE
export const CONSTANTS = {
    HOMEPAGE_SLUG: "2-KongaTV",
    KONGA_NOW_HEADER: "kongav3",
}

Object.freeze(CONSTANTS);

